// import React, { Component } from "react";
// import { Col, Row, Form, Container, Image } from "react-bootstrap";
// import { toast } from "react-toastify";
// //import { Link } from "react-router-dom";
// import configData from "../config.json";
// export default class ZunoQuotes extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isdefault: false,
//       show: false,
//       showOne: false,
//       showTest: false,
//       showModal: false,
//       proposalId: sessionStorage.getItem("proposalId"),
//       baseproductId: sessionStorage.getItem("baseproductId"),
//       integId: 342,
//       responseId: 1748071290,
//       requestId: sessionStorage.getItem("requestId"),
//       quotes: [],
//       policyData: null,
//       contractDetails: [],
//       highlights: [],
//       selectedProduct: null,
//       productBenefits: [],
//       isLoading: true,
//       policiesCondition: false,
//     };
//   }
//   showToast = (msg, type) => {
//     var tType = toast.TYPE.INFO;
//     if (type === "success") tType = toast.TYPE.SUCCESS;
//     if (type === "error") tType = toast.TYPE.ERROR;
//     if (type === "warning") tType = toast.TYPE.WARNING;
//     toast(msg, { type: tType });
//   };
//   componentDidMount() {
//     setTimeout(() => {
//       this.setState({ isLoading: false });
//       // const { proposalId } = this.state;
//       // var fd = new FormData();
//       // fd.append("proposalId", proposalId);
//       // console.log(proposalId);
//       // fetch(configData.api_url + "leads/getquotes/", {
//       //   method: "POST",
//       //   mode: "cors",
//       //   body: fd, // body data type must match "Content-Type" header
//       // })
//       //   .then((response) => response.json())
//       //   .then((data) => {
//       //     console.log(this.state.quotes);
//       //     this.showToast(data.message, data.success);
//       //     if (data.status === "success") {
//       //       console.log(data.quotes);
//       //       this.setState({ quotes: data.quotes });
//       //       this.HealthproductsfeaturesfetchHandler();
//       //     }
//       //   });
//       // console.log(this.state.quotes);
//       const formData = new FormData();
//       formData.append("sId", this.state.sId);
//       formData.append("uId", this.state.uId);
//       formData.append("integId", this.state.integId);
//       formData.append("requestId", this.state.requestId);
//       fetch(
//         configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
//         {
//           method: "POST",
//           mode: "cors",
//           body: formData, // body data type must match "Content-Type" header
//         }
//       )
//         .then((response) => response.json())
//         .then((data) => {
//           if (data.status === "success" && data.data) {
//             this.setState({
//               quotes: data.data,
//             });
//           }
//         });
//     }, 80000);
//   }
//   handleBackPasswordClick = (quote) => {
//     // const chpiId = quote.chpiId;
//     // const cqrId = quote.cqrId;
//     // const baseproductId = quote.baseproductId;
//     // const insurername = quote.insurername;
//     // //const productcode = quote.productcode;

//     // console.log(baseproductId);
//     // const { proposalId } = this.state;
//     // sessionStorage.setItem("chpiId", chpiId);
//     // sessionStorage.setItem("cqrId", cqrId);
//     // sessionStorage.setItem("baseproductId", baseproductId);
//     // var fd = new FormData();
//     // fd.append("proposalId", proposalId);
//     // fd.append("cqrId", cqrId);
//     // fd.append("chpiId", chpiId);
//     // fd.append("baseproductId", baseproductId);
//     // console.log(proposalId);
//     // // if (insurername === "Care Health Insurance") {
//     // //   window.location.href = "/addons";
//     // // }
//     // fetch(configData.api_url + "leads/updateproposal/", {
//     //   method: "POST",
//     //   mode: "cors",
//     //   body: fd, // body data type must match "Content-Type" header
//     // })
//     //   .then((response) => response.json())
//     //   .then((data) => {
//     //     console.log(this.state.quotes);
//     //     this.showToast(data.message, data.success);
//     //     if (data.status === "success") {
//     //       this.setState({ policiesCondition: true });
//     //     }
//     //   });
//     window.location.href = "/zunoaddons";
//   };

//   render() {
//     const { isLoading } = this.state;
//     if (isLoading) {
//       return (
//         <div>
//           <div className="text-center mt-5">
//             <div className="spinner-grow text-primary" role="status">
//               <span className="visually-hidden"></span>
//             </div>
//             <div className="spinner-grow text-success" role="status">
//               <span className="visually-hidden"></span>
//             </div>
//             <div className="spinner-grow text-danger" role="status">
//               <span className="visually-hidden"></span>
//             </div>
//             <div className="spinner-grow text-warning" role="status">
//               <span className="visually-hidden"></span>
//             </div>
//             <div className="spinner-grow text-info" role="status">
//               <span className="visually-hidden"></span>
//             </div>
//             <div className="spinner-grow text-light" role="status">
//               <span className="visually-hidden"></span>
//             </div>
//             <div>We are Bringing Best Quotes For You...</div>
//           </div>
//         </div>
//       );
//     }
//     return (
//       <div>
//         <h3 className="logoskybluecolor">Zuno Quotes</h3>
//         <Container className="thm-container bgColorContainer mt-3">
//           <Row className="comparePolicyScreenTopHeading">
//             <Col lg="2" md="2" sm="2" className="text-center">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 id="comparePolocies"
//                 onClick={this.handleCompareClick}
//               >
//                 Compare
//               </button>
//             </Col>
//             <Col lg="4" md="4" sm="4"></Col>
//             <Col lg="3" md="3" sm="3">
//               <Form>
//                 <Row>
//                   <Col lg="4" md="4" sm="4">
//                     <Form.Group className="form-group">
//                       <Form.Label
//                         className="control-label col-form-label"
//                         style={{ color: "white" }}
//                       >
//                         Cover:
//                       </Form.Label>
//                     </Form.Group>
//                   </Col>
//                   <Col lg="8" md="8" sm="8">
//                     <Form.Group className="form-group">
//                       <Form.Select
//                         aria-label="Default select example"
//                         // value={sumInsured}
//                         onChange={this.handleChange}
//                         className="form-control"
//                         id="sumInsured"
//                       >
//                         <option value="">Choose Cover</option>
//                         <option value="1***3">1 lakh to 3 lakh</option>
//                         <option value="3***6">3 lakh to 6 lakh</option>
//                         <option value="6***9">6 lakh to 9 lakh</option>
//                         <option value="9***12">9 lakh to 12 lakh</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//               </Form>
//             </Col>
//             <Col lg="3" md="3" sm="3">
//               <Form>
//                 <Row>
//                   <Col lg="5" md="5" sm="5">
//                     <Form.Group className="form-group">
//                       <Form.Label
//                         className="control-label col-form-label font-weight-bold"
//                         style={{ color: "white" }}
//                       >
//                         Plan Type:
//                       </Form.Label>
//                     </Form.Group>
//                   </Col>
//                   <Col lg="7" md="7" sm="7">
//                     <Form.Group className="form-group">
//                       <Form.Select
//                         aria-label="Default select example"
//                         // defaultValue={this.state.customer.planType}
//                         className="form-control"
//                         id="planType"
//                       >
//                         <option value="Base">Base</option>
//                         <option value="Top">TopUp</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//               </Form>
//             </Col>
//           </Row>
//           <Row>
//             <br />
//             <input type="hidden" id="itId" value=""></input>
//             <input
//               type="hidden"
//               id="chihealthplansintegrated_Id"
//               value=""
//             ></input>
//           </Row>
//           <br />
//           <Row>
//             {this.state.quotes ? (
//               typeof this.state.quotes === "object" &&
//               !Array.isArray(this.state.quotes) ? (
//                 this.state.quotes.data &&
//                 this.state.quotes.data.policyData &&
//                 this.state.quotes.data.policyData.applicablePlans ? (
//                   Object.keys(
//                     this.state.quotes.data.policyData.applicablePlans
//                   ).map((planName, index) => {
//                     const plan =
//                       this.state.quotes.data.policyData.applicablePlans[
//                         planName
//                       ];
//                     return (
//                       <div key={index} className="compareDetailssection">
//                         <Col
//                           lg="12"
//                           md="12"
//                           sm="12"
//                           className="compareDetailssectionleft"
//                         >
//                           <Row className="compareDetailssectionleftbox">
//                             <Col
//                               lg="1"
//                               md="1"
//                               sm="1"
//                               style={{
//                                 justifyContent: "center",
//                                 marginTop: "60px",
//                               }}
//                             >
//                               <input
//                                 type="hidden"
//                                 className="chihealthplansintegrated_Id mt-2"
//                                 style={{ justifyContent: "center" }}
//                                 value={plan.planId || index}
//                               />
//                               <input
//                                 type="checkbox"
//                                 className="compareP"
//                                 checked={plan.isSelected || false}
//                                 onChange={() =>
//                                   this.handlePlanSelection &&
//                                   this.handlePlanSelection(plan.planId || index)
//                                 }
//                               />
//                             </Col>
//                             <Col lg="2" md="2" sm="2">
//                               <Image
//                                 style={{
//                                   width: "100%",
//                                   marginLeft: "5px",
//                                   marginTop: "10px",
//                                 }}
//                                 src={configData.static_url + "default-logo.png"}
//                                 alt="Plan Logo"
//                               />
//                             </Col>
//                             <Col lg="2" md="2" sm="2">
//                               <p className="mt-3">Product Name - {planName}</p>
//                               <p className="mt-3">
//                                 Tenure -{" "}
//                                 {this.state.quotes.data.policyData
//                                   ?.contractDetails?.[0]?.policyTerm || 1}{" "}
//                                 Year
//                               </p>
//                               <p className="mt-3">
//                                 Cover Type -{" "}
//                                 {this.state.quotes.data.policyData
//                                   ?.policyType || "Floater"}
//                               </p>
//                             </Col>
//                             <Col lg="1" md="1" sm="2">
//                               <p>Sum Insured</p>
//                               <b>
//                                 ₹
//                                 {(
//                                   this.state.quotes.data.policyData
//                                     ?.contractDetails?.[0]?.sumInsured || 500000
//                                 )?.toLocaleString()}
//                               </b>
//                             </Col>
//                             <Col lg="4" md="4" sm="2">
//                               <p>Benefits</p>
//                               <div>
//                                 {plan.subCoverages &&
//                                 Object.keys(plan.subCoverages).length > 0 ? (
//                                   Object.keys(plan.subCoverages)
//                                     .slice(0, 5)
//                                     .map((coverage) => (
//                                       <div key={coverage}>
//                                         <small>
//                                           {coverage}:{" "}
//                                           {plan.subCoverages[coverage]
//                                             .benefit || "Available"}
//                                         </small>
//                                         <br />
//                                       </div>
//                                     ))
//                                 ) : (
//                                   <small>
//                                     Standard health insurance benefits
//                                   </small>
//                                 )}
//                               </div>
//                             </Col>
//                             <Col
//                               lg="2"
//                               md="2"
//                               sm="3"
//                               className="comparepagesLastDiv"
//                             >
//                               <div style={{ textAlign: "center" }}>
//                                 {plan.premiumDetails ? (
//                                   <>
//                                     <button
//                                       onClick={() =>
//                                         this.handleBackPasswordClick &&
//                                         this.handleBackPasswordClick(plan)
//                                       }
//                                       className="btn btn-primary"
//                                       style={{
//                                         color: "#ffffff",
//                                         backgroundColor: plan.isSelected
//                                           ? "#28a745"
//                                           : "#007bff",
//                                         marginTop: "10px",
//                                       }}
//                                     >
//                                       ₹
//                                       {plan.premiumDetails.totalPremium?.toLocaleString()}
//                                       /-
//                                     </button>
//                                   </>
//                                 ) : (
//                                   <button
//                                     onClick={() =>
//                                       this.handleBackPasswordClick &&
//                                       this.handleBackPasswordClick(plan)
//                                     }
//                                     className="btn btn-primary"
//                                     style={{ color: "#ffffff" }}
//                                   >
//                                     View Details
//                                   </button>
//                                 )}
//                               </div>
//                             </Col>
//                           </Row>
//                         </Col>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <Col lg="12" className="text-center">
//                     <p>Policy data structure not found</p>
//                     <p>
//                       Available keys in quotes:{" "}
//                       {Object.keys(this.state.quotes).join(", ")}
//                     </p>
//                     {this.state.quotes.data && (
//                       <p>
//                         Available keys in quotes.data:{" "}
//                         {Object.keys(this.state.quotes.data).join(", ")}
//                       </p>
//                     )}
//                   </Col>
//                 )
//               ) : Array.isArray(this.state.quotes) ? (
//                 this.state.quotes.map((plan, index) => (
//                   // Handle if it's an array (original logic)
//                   <div key={index} className="compareDetailssection">
//                     {/* Array handling code would go here */}
//                   </div>
//                 ))
//               ) : (
//                 <Col lg="12" className="text-center">
//                   <p>Invalid data format received</p>
//                 </Col>
//               )
//             ) : (
//               <Col lg="12" className="text-center">
//                 <p>No data available</p>
//               </Col>
//             )}
//           </Row>
//           <br />
//         </Container>
//       </div>
//     );
//   }
// }
import React, { Component } from "react";
import { Col, Row, Form, Container, Image } from "react-bootstrap";
import { toast } from "react-toastify";
//import { Link } from "react-router-dom";
import configData from "../config.json";
import Zunoimage from "../ZUNO/Zunoimage.svg";
export default class ZunoQuotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      isdefault: false,
      show: false,
      showOne: false,
      showTest: false,
      showModal: false,
      proposalId: sessionStorage.getItem("proposalId"),
      baseproductId: sessionStorage.getItem("baseproductId"),
      integId: 357,
      //responseId: 1748071290,
      requestId: sessionStorage.getItem("requestId"),
      quotes: [],
      policyData: null,
      contractDetails: [],
      highlights: [],
      selectedProduct: null,
      productBenefits: [],
      isLoading: true,
      policiesCondition: false,
    };
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({ isLoading: false });
      this.ResponsejsonfetchHandler();
    }, 12000);
    //this.ResponsejsonfetchHandler();
  }
  ResponsejsonfetchHandler = (format = "nested") => {
    this.setState({ isLoading: true });
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("requestId", this.state.requestId);
    //formData.append("responseId", this.state.requestId);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData, // body data type must match "Content-Type" header
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.data) {
          this.setState({
            quotes: data.data,
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false }); // stop loader if no success
        }
      });
  };
  handleBackPasswordClick = (planName, planData) => {
    // Correct way to access the data based on your API response structure
    // const policyData = this.state.quotes?.data?.policyData;
    // const insuredMembers =
    //   this.state.quotes?.data?.policyData?.contractDetails?.[0]?.insuredMembers;
    // const policyId = this.state.quotes?.data?.policyData?.policyId;
    const fullPolicyData = this.state.quotes?.data?.policyData;
    const insuredMembers = fullPolicyData?.contractDetails?.[0]?.insuredMembers;
    const policyId = fullPolicyData?.policyId;
    if (fullPolicyData && insuredMembers && planData && policyId) {
      // Make a shallow copy of policyData and replace applicablePlans
      const selectedPolicyData = {
        ...fullPolicyData,
        applicablePlans: {
          [planName]: planData, // only selected plan
        },
      };

      // Store only selected plan details
      sessionStorage.setItem("selectedPlanName", planName);
      sessionStorage.setItem("selectedPlan", JSON.stringify(planData));
      sessionStorage.setItem("policyData", JSON.stringify(selectedPolicyData));
      sessionStorage.setItem("insuredMembers", JSON.stringify(insuredMembers));
      sessionStorage.setItem("policyId", policyId);
      window.location.href = "/zunoaddons";
    } else {
    }
  };

  render() {
    const { isLoading } = this.state;
    if (isLoading) {
      return (
        <div>
          <div className="text-center mt-5">
            <div className="spinner-grow text-primary" role="status">
              <span className="visually-hidden"></span>
            </div>
            <div className="spinner-grow text-success" role="status">
              <span className="visually-hidden"></span>
            </div>
            <div className="spinner-grow text-danger" role="status">
              <span className="visually-hidden"></span>
            </div>
            <div className="spinner-grow text-warning" role="status">
              <span className="visually-hidden"></span>
            </div>
            <div className="spinner-grow text-info" role="status">
              <span className="visually-hidden"></span>
            </div>
            <div className="spinner-grow text-light" role="status">
              <span className="visually-hidden"></span>
            </div>
            <div>We are Bringing Best Quotes For You...</div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <h3 className="logoskybluecolor">Zuno Quotes</h3>
        <Container className="thm-container bgColorContainer mt-3">
          <Row className="comparePolicyScreenTopHeading">
            <Col lg="2" md="2" sm="2" className="text-center">
              <button
                type="button"
                className="btn btn-secondary"
                id="comparePolocies"
                onClick={this.handleCompareClick}
              >
                Compare
              </button>
            </Col>
            <Col lg="4" md="4" sm="4"></Col>
            <Col lg="3" md="3" sm="3">
              <Form>
                <Row>
                  <Col lg="4" md="4" sm="4">
                    <Form.Group className="form-group">
                      <Form.Label
                        className="control-label col-form-label"
                        style={{ color: "white" }}
                      >
                        Cover:
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg="8" md="8" sm="8">
                    <Form.Group className="form-group">
                      <Form.Select
                        aria-label="Default select example"
                        // value={sumInsured}
                        onChange={this.handleChange}
                        className="form-control"
                        id="sumInsured"
                      >
                        <option value="">Choose Cover</option>
                        <option value="1***3">1 lakh to 3 lakh</option>
                        <option value="3***6">3 lakh to 6 lakh</option>
                        <option value="6***9">6 lakh to 9 lakh</option>
                        <option value="9***12">9 lakh to 12 lakh</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col lg="3" md="3" sm="3">
              <Form>
                <Row>
                  <Col lg="5" md="5" sm="5">
                    <Form.Group className="form-group">
                      <Form.Label
                        className="control-label col-form-label font-weight-bold"
                        style={{ color: "white" }}
                      >
                        Plan Type:
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg="7" md="7" sm="7">
                    <Form.Group className="form-group">
                      <Form.Select
                        aria-label="Default select example"
                        // defaultValue={this.state.customer.planType}
                        className="form-control"
                        id="planType"
                      >
                        <option value="Base">Base</option>
                        <option value="Top">TopUp</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          <Row>
            <br />
            <input type="hidden" id="itId" value=""></input>
            <input
              type="hidden"
              id="chihealthplansintegrated_Id"
              value=""
            ></input>
          </Row>
          <br />
          <Row>
            {this.state.quotes ? (
              typeof this.state.quotes === "object" &&
              !Array.isArray(this.state.quotes) ? (
                this.state.quotes.data &&
                this.state.quotes.data.policyData &&
                this.state.quotes.data.policyData.applicablePlans ? (
                  Object.keys(
                    this.state.quotes.data.policyData.applicablePlans
                  ).map((planName, index) => {
                    const plan =
                      this.state.quotes.data.policyData.applicablePlans[
                        planName
                      ];
                    return (
                      <div key={index} className="compareDetailssection">
                        <Col
                          lg="12"
                          md="12"
                          sm="12"
                          className="compareDetailssectionleft"
                        >
                          <Row className="compareDetailssectionleftbox">
                            <Col
                              lg="1"
                              md="1"
                              sm="1"
                              style={{
                                justifyContent: "center",
                                marginTop: "60px",
                              }}
                            >
                              <input
                                type="hidden"
                                className="chihealthplansintegrated_Id mt-2"
                                style={{ justifyContent: "center" }}
                                value={plan.planId || index}
                              />
                              <input
                                type="checkbox"
                                className="compareP"
                                checked={plan.isSelected || false}
                                onChange={() =>
                                  this.handlePlanSelection &&
                                  this.handlePlanSelection(plan.planId || index)
                                }
                              />
                            </Col>
                            <Col lg="2" md="2" sm="2">
                              <Image
                                style={{
                                  width: "100%",
                                  // marginLeft: "5px",
                                  marginTop: "50px",
                                }}
                                src={Zunoimage}
                                // src={configData.static_url + "default-logo.png"}
                                alt="Plan Logo"
                              />
                            </Col>
                            <Col lg="2" md="2" sm="2">
                              <p className="mt-3">Product Name - {planName}</p>
                              <p className="mt-3">
                                Tenure -{" "}
                                {this.state.quotes.data.policyData
                                  ?.contractDetails?.[0]?.policyTerm || 1}{" "}
                                Year
                              </p>
                              <p className="mt-3">
                                Cover Type -{" "}
                                {this.state.quotes.data.policyData
                                  ?.policyType || "Floater"}
                              </p>
                            </Col>
                            <Col lg="1" md="1" sm="2">
                              <p>Sum Insured</p>
                              <b>
                                ₹
                                {(
                                  this.state.quotes.data.policyData
                                    ?.contractDetails?.[0]?.sumInsured || 500000
                                )?.toLocaleString()}
                              </b>
                            </Col>
                            <Col lg="4" md="4" sm="2">
                              <p>Benefits</p>
                              <div>
                                {plan.subCoverages &&
                                Object.keys(plan.subCoverages).length > 0 ? (
                                  Object.keys(plan.subCoverages)
                                    .slice(0, 5)
                                    .map((coverage) => (
                                      <div key={coverage}>
                                        <small>
                                          {coverage}:{" "}
                                          {plan.subCoverages[coverage]
                                            .benefit || "Available"}
                                        </small>
                                        <br />
                                      </div>
                                    ))
                                ) : (
                                  <small>
                                    Standard health insurance benefits
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col
                              lg="2"
                              md="2"
                              sm="3"
                              className="comparepagesLastDiv"
                            >
                              <div style={{ textAlign: "center" }}>
                                {plan.premiumDetails ? (
                                  <>
                                    <button
                                      // onClick={() =>
                                      //   this.handleBackPasswordClick &&
                                      //   this.handleBackPasswordClick(plan)
                                      // }
                                      onClick={() =>
                                        this.handleBackPasswordClick(
                                          planName,
                                          plan
                                        )
                                      }
                                      className="btn btn-primary"
                                      style={{
                                        color: "#ffffff",
                                        backgroundColor: plan.isSelected
                                          ? "#28a745"
                                          : "#007bff",
                                        marginTop: "60px",
                                      }}
                                    >
                                      ₹
                                      {plan.premiumDetails.totalPremium?.toLocaleString()}
                                      /-
                                    </button>
                                  </>
                                ) : (
                                  <button
                                    onClick={() =>
                                      this.handleBackPasswordClick &&
                                      this.handleBackPasswordClick(plan)
                                    }
                                    className="btn btn-primary"
                                    style={{ color: "#ffffff" }}
                                  >
                                    View Details
                                  </button>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    );
                  })
                ) : (
                  <Col lg="12" className="text-center">
                    <p>Policy data structure not found</p>
                    <p>
                      Available keys in quotes:{" "}
                      {Object.keys(this.state.quotes).join(", ")}
                    </p>
                    {this.state.quotes.data && (
                      <p>
                        Available keys in quotes.data:{" "}
                        {Object.keys(this.state.quotes.data).join(", ")}
                      </p>
                    )}
                  </Col>
                )
              ) : Array.isArray(this.state.quotes) ? (
                this.state.quotes.map((plan, index) => (
                  // Handle if it's an array (original logic)
                  <div key={index} className="compareDetailssection">
                    {/* Array handling code would go here */}
                  </div>
                ))
              ) : (
                <Col lg="12" className="text-center">
                  <p>Invalid data format received</p>
                </Col>
              )
            ) : (
              <Col lg="12" className="text-center">
                <p>No data available</p>
              </Col>
            )}
          </Row>
          <br />
        </Container>
      </div>
    );
  }
}
